export enum WorkspaceDetailsTab {
  SETTINGS = 'settings',
  GROUPS = 'groups',
  DOCUMENTS = 'documents',
}
